<template>
<div  class="modules">
    <div class="modulesCon">
      <div class="modules_li modules_li1" @click="toActiv()">
	   <div class="modules_bg"></div>
        <div class="modules_mask"></div>
        <div class="modules_li_inner">
          <div class="modules_li_tp wow fadeInUp">
            <i class="mo_ico1"></i>
          </div>
          <p class="modules_li_p wow fadeInUp">品牌活动</p>
        </div>
      </div>
       <div class="modules_li modules_li2" @click="toService()">
	    <div class="modules_bg"></div>
        <div class="modules_mask"></div>
        <div class="modules_li_inner">
          <div class="modules_li_tp wow fadeInUp">
            <i class="mo_ico2"></i>
          </div>
          <p class="modules_li_p wow fadeInUp">大客户购车</p>
        </div>
      </div>
       <div class="modules_li modules_li3" @click="toNews1()">
	    <div class="modules_bg"></div>
        <div class="modules_mask"></div>
        <div class="modules_li_inner">
          <div class="modules_li_tp wow fadeInUp">
            <i class="mo_ico3"></i>
          </div>
          <p class="modules_li_p wow fadeInUp">新闻资讯</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {


      }
    },
    created () {
    },

    mounted () {
// 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
    },
    methods: {
      toActiv(){
        this.$router.push({
            name: 'story',
            query: {
            },
          })
      },
      toService(){
        this.$router.push({
            name: 'service',
            query: {
            },
          })
      },
      toNews1(){
        this.$router.push({
            name: 'news1',
            query: {
            },
          })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/modules.vue